import { usePostNavigation } from '@/features/(insight)/posts/hooks/use-post-navigation';
import { useFetchReferencedPosts } from '@/features/(insight)/referenced-posts/hooks/use-fetch-referenced-posts';
import { ToggleStage } from '@/shared/components/stage/toggle-stage';
import { cn } from '@/shared/utils/cn';
import { ExamplePostItem, ExamplePostItemSkeleton } from '../example-post-item';

export type ThemePostParams = {
  session_id: string;
  answer_id: string;
  theme_id: string;
  block_id: string;
};

export const ThemePostContainer = (props: { className?: string; params: ThemePostParams }) => {
  const { data } = useFetchReferencedPosts(
    {
      session_id: props.params.session_id,
      block_id: props.params.block_id,
      answer_id: props.params.answer_id,
      parts: 'theme',
      part_id: props.params.theme_id,
      limit: 3,
      order: 'score',
    },
    true,
  );

  const toPostPage = usePostNavigation();

  return (
    <ToggleStage
      className={cn('grid grid-cols-3 gap-2', props.className)}
      status={!!data}
      fallback={
        <>
          <ExamplePostItemSkeleton />
          <ExamplePostItemSkeleton />
          <ExamplePostItemSkeleton />
        </>
      }
    >
      {data?.posts?.map((post) => (
        <ExamplePostItem key={post._id} post={post} onClick={() => toPostPage(post._id)} />
      ))}
    </ToggleStage>
  );
};
